import { render, staticRenderFns } from "./OutboxEmailListing.vue?vue&type=template&id=6ba157cd&scoped=true&"
import script from "./OutboxEmailListing.vue?vue&type=script&lang=js&"
export * from "./OutboxEmailListing.vue?vue&type=script&lang=js&"
import style0 from "./OutboxEmailListing.vue?vue&type=style&index=0&id=6ba157cd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba157cd",
  null
  
)

export default component.exports